import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home-stats',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './home-stats.component.html',
  styleUrl: './home-stats.component.scss',
})
export class HomeStatsComponent {
  readonly stats = [
    { valueKey: 'Claim-A-number', labelKey: 'Claim-A-text' },
    { valueKey: 'Claim-B-number', labelKey: 'Claim-B-text' },
    { valueKey: 'Claim-C-number', labelKey: 'Claim-C-text' },
    { valueKey: 'Claim-D-number', labelKey: 'Claim-D-text' },
  ];
}
